import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'redux/store';
import { RootState } from 'redux/schemas';
import { getAiRolePlayAvailableVoiceOptions } from 'redux/actions/ai-role-play';

// Module-level so concurrent consumers of the hook (e.g. the character edit
// view and the voice list) share a single in-flight request
let isRequestInFlight = false;
let lastFetchedCatalogId: string | null = null;

/* @ngInject */
export default function useAiRolePlayVoiceOptions(catalogId: string) {
  const dispatch = useAppDispatch();
  const voiceOptions = useSelector((state: RootState) => state.models.aiRolePlayAvailableVoiceOptions);

  useEffect(() => {
    if (catalogId
      && !isRequestInFlight
      && (lastFetchedCatalogId !== catalogId || !voiceOptions.length)
    ) {
      isRequestInFlight = true;
      lastFetchedCatalogId = catalogId;
      dispatch(getAiRolePlayAvailableVoiceOptions({ catalogId })).finally(() => {
        isRequestInFlight = false;
      });
    }
  }, [voiceOptions.length, catalogId, dispatch]);

  return voiceOptions;
}
